var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Navbar',{staticStyle:{"z-index":"1000"}}),_c('router-view',{staticClass:"mt-5 pt-3"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }